<script>
export default {
    name: 'IconBase',
    props: {
        color: {
            type: String,
            default: '#8b8fa3'
        }
    }
}
</script>
